"use client";

import React, { useEffect, useRef } from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "100%",
  label: "Call Coverage",
  description: "Never miss a business opportunity"
}, {
  value: "24/7",
  label: "Availability",
  description: "Always on, day and night"
}, {
  value: "3x",
  label: "Lead Conversion",
  description: "Turn more callers into customers"
}];
export default function BusinessOutcomes() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        const speed = 0.15;
        parallaxRef.current.style.transform = `translateY(${scrolled * speed}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="business-outcomes" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-24 md:py-32">
      {}
      <div ref={parallaxRef} className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-10 select-none" aria-hidden="true">
        <span className="text-[15vw] font-black tracking-tighter text-primary whitespace-nowrap blur-sm">
          OUTCOMES
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className={`flex flex-col items-center justify-center gap-8 md:flex-row md:gap-0 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {stats.map((stat, i) => <React.Fragment key={i}>
              {}
              <div data-index={i} className="flex flex-1 flex-col items-center justify-center text-center">
                <span className="text-7xl font-light tracking-tight text-primary md:text-8xl lg:text-9xl">
                  {stat.value}
                </span>
                <span className="mt-2 text-xl font-bold uppercase tracking-widest text-primary md:text-2xl">
                  {stat.label}
                </span>
                <p className="mt-2 text-sm font-medium text-muted-foreground">
                  {stat.description}
                </p>
              </div>

              {}
              {i < stats.length - 1 && <>
                  {}
                  <div className="hidden h-32 items-center justify-center px-8 md:flex lg:px-12">
                    <Separator orientation="vertical" className="h-full w-[1px] bg-primary/20" />
                  </div>

                  {}
                  <div className="flex w-full items-center justify-center py-8 md:hidden">
                    <Separator orientation="horizontal" className="h-[1px] w-24 bg-primary/20" />
                  </div>
                </>}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}